import { render, staticRenderFns } from "./HealthScoreIcon.vue?vue&type=template&id=1a1dc606&scoped=true&"
import script from "./HealthScoreIcon.vue?vue&type=script&lang=js&"
export * from "./HealthScoreIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1dc606",
  null
  
)

export default component.exports